module.exports = __webpack_public_path__ + "static/media/ucd_logo.3ef9c7d2.png";